
import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

/** Asignaciones de producción (tabla production_users) del módulo Producción */
export default {
    getByRemission(remissionId) {
        return axios.get(`${API_URL}/production-users`, {
            params: { remission_id: remissionId },
            headers: authHeader(),
        });
    },
    createData(data) {
        return axios.post(`${API_URL}/production-users`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/production-users/${id}`, data, { headers: authHeader() });
    },
    updateStatus(id, status) {
        return axios.put(`${API_URL}/production-users/${id}/status`, { status }, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/production-users/${id}`, { headers: authHeader() });
    },
};
